import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import { List, ListItem } from 'material-ui/List'
import { Card, CardText } from 'material-ui/Card'
import {
  Paper,
  Dialog,
  MenuItem,
  Snackbar,
  TextField,
  Subheader,
  DatePicker,
  TimePicker,
  FlatButton,
  SelectField,
  RaisedButton,
  CircularProgress
} from 'material-ui'
import {
  Table,
  TableRow,
  TableBody,
  TableFooter,
  TableHeader,
  TableRowColumn,
  TableHeaderColumn
} from 'material-ui/Table'
import moment from 'moment'
import Header from '../../components/Header/Header'
import Constants from '../../utils/CommonConstants'
import Documents from '../../components/Documents/Documents'
import FileDetails from '../../components/Common/FileDetails'
import BrokerOrderDetails from './BrokerOrderDetails'
import PaymentOrderDetails from './PaymentOrderDetails'
import TermsheetOrderDetails from './TermsheetOrderDetails'
import {
  getOrderDocuments,
  getDeveloperDetails,
  getAccountLegalEntityDetails,
  deleteOrderDocuments,
  deleteOrderInvoice,
  ORDER_REFRESHED,
  getOrderDetails,
  getOrderCommentReasons,
  refreshBrokerOrderDocuments,
  saveOrderDetails,
  editPaymentModeDetails
} from '../../actions/order'
import {
  LOAD_COUNT_DECREMENT,
  LOAD_COUNT_INCREMENT,
  SHOW_SNACKBAR_TOASTR
} from '../../actions/loading'
import RefundOrderDetails from './RefundOrderDetails'

const mapStateToProps = state => ({
  documents: state.documents,
  developerDetails: state.developerDetails,
  legalEntityDetails: state.legalEntityDetails,
  caseReasonsMap: state.caseReasonsMap,
  isSalesRoleOnly: state.isSalesRoleOnly,
  caseStatusMap: state.caseStatusMap,
  paymentStatusMap: state.paymentStatusMap,
  refreshOrder: state.refreshOrder,
  brokerDocuments: state.brokerDocuments,
  order: state.order,
  orderUpdated: state.orderUpdated,
  paymentModeUpdated: state.paymentModeUpdated,
  reasonList: state.reasonList,
  isStatusUpdated: state.isStatusUpdated,
  userInfo: state.userInfo,
  isRcmAdmin: state.isRcmAdmin,
  isStatusOnline: state.isStatusOnline
})
const mapDispatchToProps = dispatch => {
  return {
    getOrderDocuments: bindActionCreators(getOrderDocuments, dispatch),
    getDeveloperDetails: bindActionCreators(getDeveloperDetails, dispatch),
    getAccountLegalEntityDetails: bindActionCreators(
      getAccountLegalEntityDetails,
      dispatch
    ),
    deleteOrderDocuments: bindActionCreators(deleteOrderDocuments, dispatch),
    deleteOrderInvoice: bindActionCreators(deleteOrderInvoice, dispatch),
    getOrderDetails: bindActionCreators(getOrderDetails, dispatch),
    saveOrderDetails: bindActionCreators(saveOrderDetails, dispatch),
    editPaymentModeDetails: bindActionCreators(
      editPaymentModeDetails,
      dispatch
    ),
    getOrderCommentReasons: bindActionCreators(
      getOrderCommentReasons,
      dispatch
    ),
    refreshBrokerOrderDocuments: bindActionCreators(
      refreshBrokerOrderDocuments,
      dispatch
    ),
    dispatch
  }
}

const DATE_FORMAT = 'YYYY-MM-DD'
if (process.env.WEBPACK) {
  require('./OrderDetails.css')
}

class OrderDetails extends Component {
  constructor(props) {
    super(props)
    this.state = {
      noCaseToPull: false,
      reasonList: [],
      brokerDocuments: {},
      isloading: true
    }
    this.putSuccessHandler = this.putSuccessHandler.bind(this)
  }
  putSuccessHandler() {
    this.resetDashboardStats()
    browserHistory.goBack()
  }

  resetDashboardStats = () => {
    const { dispatch } = this.props
    dispatch({
      type: 'DASHBOARD_STATS_RESET'
    })
  }

  componentWillMount() {
    const orderID = this.props.params.orderId
    this.props.getOrderDetails(orderID)
  }
  componentWillReceiveProps(nextProps) {
    const { props } = this
    if (
      nextProps.refreshOrder &&
      nextProps.refreshOrder !== props.refreshOrder
    ) {
      const orderID = props.params.orderId
      props.getOrderDetails(orderID)
      props.dispatch({
        type: ORDER_REFRESHED
      })
      return
    }
    if (nextProps.order !== props.order) {
      this.setState({
        OrderDetails: nextProps.order,
        brokerDocuments:
          nextProps.order &&
          nextProps.order.platform_order_details &&
          nextProps.order.platform_order_details.documents,
        noCaseToPull: false,
        reasonList: [],
        isloading: false
      })
      const { rcmOrder } = nextProps.order
      const currentStatusId = rcmOrder.statusId,
        caseSubTypeId = rcmOrder.caseSubTypeId
      props.getOrderCommentReasons({ currentStatusId, caseSubTypeId })
    }
    if (
      (nextProps.reasonList !== props.reasonList ||
        nextProps.caseReasonsMap !== props.caseReasonsMap) &&
      Object.keys(nextProps.caseReasonsMap).length
    ) {
      const masterReasonMap = nextProps.caseReasonsMap
      this.setState({
        reasonList: nextProps.reasonList.map(item => {
          return {
            id: item.reasonId,
            label: masterReasonMap[item.reasonId],
            nextStatusId: item.nextStatusId
          }
        })
      })
    }
    if (nextProps.brokerDocuments !== props.brokerDocuments) {
      this.setState({
        brokerDocuments: nextProps.brokerDocuments
      })
    }
    if (nextProps.orderUpdated !== props.orderUpdated) {
      const orderID = this.props.params.orderId
      this.props.getOrderDetails(orderID)
    }
    if (nextProps.paymentModeUpdated !== props.paymentModeUpdated) {
      browserHistory.goBack()
    }
  }
  componentDidMount() {
    this.props.router.setRouteLeaveHook(
      this.props.route,
      this.routerWillLeave.bind(this)
    )
  }
  routerWillLeave(nextLocation) {
    if (
      nextLocation.pathname.indexOf('/detail/') !== -1 &&
      this.props.isStatusOnline
    ) {
      return
    }
  }
  render() {
    let {
      OrderDetails,
      noCaseToPull,
      reasonList,
      brokerDocuments = {}
    } = this.state
    const { userInfo = {}, isRcmAdmin } = this.props

    if (noCaseToPull) {
      return (
        <div>
          <Header {...this.props} />
          <center>No Case to Pull. Please try again later.</center>
        </div>
      )
    }
    return (
      <div>
        <Header {...this.props} />
        {this.state.isloading ? (
          <div />
        ) : (
          (() => {
            if (OrderDetails && OrderDetails.rcmOrder) {
              const rcmOrder = OrderDetails.rcmOrder
              switch (rcmOrder.caseSubTypeId) {
                case Constants.CaseSubTypeMap.BROKER_ORDER:
                  return (
                    <BrokerOrderDetails
                      order={OrderDetails}
                      reasonList={reasonList}
                      putHandler={this.props.saveOrderDetails}
                      dispatch={this.props.dispatch}
                      caseStatusMap={this.props.caseStatusMap}
                      brokerDocuments={brokerDocuments}
                      refreshBrokerOrderDocuments={
                        this.props.refreshBrokerOrderDocuments
                      }
                    />
                  )
                case Constants.CaseSubTypeMap.BROKER.PAYMENTS:
                case Constants.CaseSubTypeMap.DEVELOPER.PAYMENTS:
                case Constants.CaseSubTypeMap.MAKAAN.PAYMENTS:
                case Constants.CaseSubTypeMap.OWNER.PAYMENTS:
                  return (
                    <PaymentOrderDetails
                      userInfo={userInfo}
                      order={OrderDetails}
                      isSalesRoleOnly={this.props.isSalesRoleOnly}
                      reasonList={reasonList}
                      putHandler={this.props.saveOrderDetails}
                      editPaymentModeDetails={this.props.editPaymentModeDetails}
                      dispatch={this.props.dispatch}
                      documents={this.props.documents}
                      getOrderDocuments={this.props.getOrderDocuments}
                      getDeveloperDetails={
                        this.props.getAccountLegalEntityDetails
                      }
                      developerDetails={this.props.legalEntityDetails}
                      paymentStatusMap={this.props.paymentStatusMap}
                      caseStatusMap={this.props.caseStatusMap}
                      isRcmAdmin={Boolean(isRcmAdmin)}
                      deleteOrderInvoice={this.props.deleteOrderInvoice}
                      deleteOrderDocuments={this.props.deleteOrderDocuments}
                    />
                  )
                case Constants.CaseSubTypeMap.BROKER.TERMSHEET:
                case Constants.CaseSubTypeMap.DEVELOPER.TERMSHEET:
                case Constants.CaseSubTypeMap.MAKAAN.TERMSHEET:
                  return (
                    <TermsheetOrderDetails
                      order={OrderDetails}
                      isSalesRoleOnly={this.props.isSalesRoleOnly}
                      reasonList={reasonList}
                      putHandler={this.props.saveOrderDetails}
                      dispatch={this.props.dispatch}
                      documents={this.props.documents}
                      isRcmAdmin={Boolean(isRcmAdmin)}
                      getOrderDocuments={this.props.getOrderDocuments}
                      getDeveloperDetails={this.props.getDeveloperDetails}
                      developerDetails={this.props.developerDetails}
                      caseStatusMap={this.props.caseStatusMap}
                      deleteOrderDocuments={this.props.deleteOrderDocuments}
                    />
                  )
                case Constants.CaseSubTypeMap.BROKER.REFUND:
                case Constants.CaseSubTypeMap.DEVELOPER.REFUND:
                case Constants.CaseSubTypeMap.MAKAAN.REFUND:
                case Constants.CaseSubTypeMap.OWNER.REFUND:
                  return (
                    <RefundOrderDetails
                      order={OrderDetails}
                      isSalesRoleOnly={this.props.isSalesRoleOnly}
                      reasonList={reasonList}
                      putHandler={this.props.saveOrderDetails}
                      dispatch={this.props.dispatch}
                      documents={this.props.documents}
                      getOrderDocuments={this.props.getOrderDocuments}
                      getDeveloperDetails={this.props.getDeveloperDetails}
                      developerDetails={this.props.developerDetails}
                      paymentStatusMap={this.props.paymentStatusMap}
                      caseStatusMap={this.props.caseStatusMap}
                      isRcmAdmin={Boolean(isRcmAdmin)}
                      deleteOrderInvoice={this.props.deleteOrderInvoice}
                      deleteOrderDocuments={this.props.deleteOrderDocuments}
                    />
                  )
              }
            } else {
              return <div />
            }
          })()
        )}
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetails)



/** WEBPACK FOOTER **
 ** ./src/containers/OrderDetails/OrderDetails.js
 **/